const ISO_DURATION_REGEX = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)(?:\.(\d+))?S)?/;
export const DEFAULT_OPTIONS = [
    { displayName: "Immediately", value: 0 },
    { displayName: "In 15 minutes", value: 900000 },
    { displayName: "In 30 minutes", value: 1800000 },
    { displayName: "In 1 hour", value: 3600000 },
    { displayName: "The next day", value: 86400000 },
    { displayName: "After a month", value: 2592000000 },
];
export const options = [
    { displayName: "Minutes", value: 60000 },
    { displayName: "Hours", value: 3600000 },
    { displayName: "Days", value: 86400000 },
    { displayName: "Weeks", value: 604800000 },
    { displayName: "Months", value: 2592000000 },
    { displayName: "Years", value: 31536000000 },
];
export function isoDurationToMillis(value) {
    const match = value.match(ISO_DURATION_REGEX);
    if (match) {
        let [, hours, minutes, seconds, millis] = match.map(Number);
        return (millis +
            seconds * 1000 +
            minutes * 60 * 1000 +
            hours * 60 * 60 * 1000);
    }
    return 0;
}
export function formattedIsoPeriod(value) {
    if (typeof value === "string") {
        const match = value.match(ISO_DURATION_REGEX);
        if (match) {
            let [, hours, minutes, seconds, millis] = match.map(Number);
            return formattedPeriod(hours, minutes, seconds, millis);
        }
    }
    if (typeof value === "number") {
        return convertMillisToUserFriendlyDuration(value);
    }
    return String(value);
}
export const convertMillisToIsoDuration = (millis) => {
    const millisecondsPerMinute = 60 * 1000;
    const millisecondsPerHour = 60 * millisecondsPerMinute;
    const hours = Math.floor(millis / millisecondsPerHour);
    const remainingAfterHours = Math.floor(millis % millisecondsPerHour);
    const minutes = Math.floor(remainingAfterHours / millisecondsPerMinute);
    const remainingAfterMinutes = remainingAfterHours % millisecondsPerMinute;
    const seconds = Math.floor(remainingAfterMinutes / 1000);
    const remainingMilliseconds = remainingAfterMinutes % 1000;
    return `PT${hours}H${minutes}M${seconds}.${remainingMilliseconds}S`;
};
const convertMillisToUserFriendlyDuration = (millis) => {
    const millisecondsPerMinute = 60 * 1000;
    const millisecondsPerHour = 60 * millisecondsPerMinute;
    const hours = Math.floor(millis / millisecondsPerHour);
    const remainingAfterHours = Math.floor(millis % millisecondsPerHour);
    const minutes = Math.floor(remainingAfterHours / millisecondsPerMinute);
    const remainingAfterMinutes = remainingAfterHours % millisecondsPerMinute;
    const seconds = Math.floor(remainingAfterMinutes / 1000);
    const remainingMilliseconds = remainingAfterMinutes % 1000;
    return formattedPeriod(hours, minutes, seconds, remainingMilliseconds);
};
function formattedPeriod(hours = 0, minutes = 0, seconds = 0, millis = 0) {
    const formattedParts = [];
    const remainingAfterHours = hours % 24;
    const days = Math.floor(hours / 24);
    if (days >= 1) {
        formattedParts.push(`${days} day${days > 1 ? "s" : ""}`);
    }
    if (remainingAfterHours >= 1) {
        formattedParts.push(`${remainingAfterHours} hour${remainingAfterHours > 1 ? "s" : ""}`);
    }
    if (minutes >= 1) {
        formattedParts.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
    }
    if (seconds >= 1) {
        formattedParts.push(`${seconds} second${seconds > 1 ? "s" : ""}`);
    }
    if (millis >= 1 || formattedParts.length === 0) {
        formattedParts.push(`${millis} millisecond${millis > 1 ? "s" : ""}`);
    }
    return formattedParts.join(" ");
}
